import { getScrollBarWidth } from './../redux/actionCreators/sync';

export default function setBrowserData(store) {
  return Promise.resolve(store.dispatch(getScrollBarWidth()));
}



// WEBPACK FOOTER //
// ./shared/utils/setBrowserData.js